import { DeleteRowConfirmationDialog } from "@/components/ax/dataTable/DeleteRowConfirmationDialog";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { showSuccess, showApiError } from "@/lib/toast";
import { deleteRole } from "@/sideEffects/api";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

interface Props {
  roleId: number;
}

export const DeleteRoleButton: React.FC<Props> = ({ roleId }) => {
  const { t } = useTranslation();

  const { goToRole } = useAppNavigate();
  const deleteRoleMutation = useMutation({
    mutationFn: (roleId: number) => deleteRole(roleId),
    onSuccess: () => {
      showSuccess(t("common.deletedSuccess"));
      goToRole();
    },
    onError: showApiError,
  });

  return (
    <DeleteRowConfirmationDialog
      onConfirmDelete={() => deleteRoleMutation.mutate(roleId)}
      isLoading={deleteRoleMutation.isPending}
    />
  );
};
